import React from 'react';
import Table from "src/componets/Table";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { ColumnsType } from "antd/es/table";
import { ButtonEdit } from "src/componets/Buttons";
import { setEditId, AppInterface } from "src/store/community/appsSlice";
import { EntityId } from "@reduxjs/toolkit";
import { formattedDate } from "src/helpers/DateHelpers";
import OptionalLink from "src/componets/OptionalLink";
import Pagination from "src/componets/Pagination";
import usePermissions from "src/hooks/usePermissions";

import { Avatar, Space } from "antd";
import { AppstoreOutlined } from "@ant-design/icons";

interface ListTableInterface {
  className?: string;
  limit: number;
}

const _ListTable = ({ className, limit }: ListTableInterface) => {
  const dispatch = useAppDispatch();
  const ids = useAppSelector(state => state.community.apps.ids);
  const apps = useAppSelector(state => state.community.apps.entities);
  const count = useAppSelector(state => state.community.apps.count);
  const { write_community } = usePermissions();
  const data  = ids ? ids.map(id => apps[id]) : [];

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  const columns: ColumnsType<AppInterface> = [
    {
      key: 'icon_url',
      title: '',
      dataIndex: 'icon_url',
      render: (_, { icon_url }) => {
        return <Avatar
          src={icon_url}
          alt='App icon'
          size={32}
          icon={<AppstoreOutlined />}
          shape='square'
        />
      },
      width: 50
    },

    {
      key: 'name',
      title: 'Name',
      render: (_, { name, url }) => <OptionalLink link={url}>{name}</OptionalLink>,
      width: 90,
      ellipsis: true
    },

    {
      key: 'bundle_name',
      title: 'Main Bundle',
      render: (_, { bundle_name, main_bundle_url }) => <OptionalLink link={main_bundle_url}>{bundle_name}</OptionalLink>,
      width: 70
    },

    {
      key: 'uid',
      title: 'UID',
      render: (_, { uid }) => <small>{uid}</small>,
      width: 60
    },

    {
      key: 'jwt_secret',
      title: 'JWT Secret',
      render: (_, { jwt_secret }) => <small>{jwt_secret}</small>,
      width: 150
    },

    {
      key: 'created_at',
      title: 'Created at',
      render: (_, { created_at }) => {
        return <small>{formattedDate(created_at).dateTime}</small>;
      },
      width: 90
    },

    ...(write_community ? [{
      key: 'action',
      title: 'Action',
      render: (_: any, { id}: AppInterface) => {
        return (
          <Space size="middle">
            <ButtonEdit key={'button-edit'} onClick={() => onClickEdit(id)} />
          </Space>
        );
      },
      width: 50
    }] : []),
  ];

  return (
    <div className={className}>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
      />

      <Pagination className='v-mt-10' total={count} size={limit} />
    </div>
  )
}

export default _ListTable;
